import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { kernersvilleConfig } from "./data";

export default function KernersvillePage() {
  return <CityPageTemplate config={kernersvilleConfig} />;
}